module.exports = __webpack_public_path__ + "media/images/vp/icon.search.black-03bb87e7e5e2ed3f694e2626630c8b11.svg";